import React, { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Wrapper, Actions, SaveBtn, LeftActions, DeleteBtn } from "./style";
import RealtimeDate from "../../components/RealtimeDate";
import { Empty } from "antd";
import { ReloadOutlined } from "@ant-design/icons";
import works from "../../services/works";
import { workConstructor } from "../../utils/workConstructor";
import Spinner from "../../components/Spinner/FullScreen";
import { NoData } from "../GroupSecretary/NewWorks/style";
import MultiDatePicker from "./../../components/FormElements/MultiDatePicker/index";
import moment from "moment";
import Select from "../../components/FormElements/Select";
import TaskCard from "components/Cards/SupervisorCard";
import { useHideModal, useShowAlert, useShowModal } from "hooks";
import Confirm from "components/Confirm";
import { FiTrash } from "react-icons/fi";
import { IoSend } from "react-icons/io5";

export default () => {
  const { error } = useShowAlert();
  const { showBlured } = useShowModal();
  const { hideModal } = useHideModal();
  const { categories, regions, groups, users } = useSelector(
    (state) => state.appReducer
  );
  const [loading, setLoading] = useState(true);
  const [worksData, setWorksData] = useState([]);
  const [pageNum, setPageNum] = useState(1);
  const { constructorMethod } = workConstructor();
  const [desc, setDesc] = useState("");
  const [workTitle, setWorkTitle] = useState("");
  const pureToday = new Date();
  const pureYesterday = new Date(pureToday);
  pureYesterday.setDate(pureYesterday.getDate() - 1);
  const [startDate, setStartDate] = useState(pureYesterday);
  const [selectedGroup, setSelectedGroup] = useState("");
  const [determinedDays, setDeterminedDays] = useState([]);

  const fetchWorks = useCallback(() => {
    const common = { categories, regions, groups, users };
    setLoading(true);
    const selectedDate = moment(startDate).format("YYYY-MM-DD");
    const postData = {
      startDate: selectedDate,
      endDate: selectedDate,
      page: pageNum,
      limit: 1,
      showpublic: true,
      status: 2,
    };
    if (selectedGroup) {
      postData["group"] = selectedGroup;
    }
    const determinedData = {
      date: moment().format("YYYY-MM-DD"),
      status: 2,
    };
    works
      .getWorkDaysForSupervisorLeader(determinedData)
      .then((res) => {
        setDeterminedDays(res);
      })
      .catch((err) => console.error(err));
    works
      .getAll(postData)
      .then(({ docs }) => {
        const workerData = constructorMethod(docs, common);
        setWorksData(workerData);
        setDesc(workerData[0]?.desc);
        setWorkTitle(workerData[0]?.title);
      })
      .catch((err) => console.error(err))
      .finally(() => setLoading(false));
  }, [startDate, pageNum, selectedGroup]);

  useEffect(() => {
    fetchWorks();
  }, [startDate, pageNum, selectedGroup]);

  const handleChangeDateInput = (dateString) => {
    setStartDate(dateString);
    setPageNum(() => 1);
  };

  const handleDescription = (input, _, field) => {
    const { value } = input.target;
    if (field === "desc") {
      setDesc(value);
    }
    if (field === "title") {
      setWorkTitle(value);
    }
  };

  // delete image
  const handleDeleteImage = (image) => {
    if (Object.keys(image).length > 0) {
      setLoading(true);
      const data = {
        id: image._id,
      };
      works
        .deleteImage(data)
        .then(() => {
          fetchWorks();
        })
        .catch((err) => console.error(err))
        .finally(() => setLoading(false));
      hideModal();
    }
  };

  // delete old images
  const handleDeleteOldImage = (image) => {
    if (Object.keys(image).length > 0) {
      setLoading(true);
      const data = {
        id: image?._id,
      };
      works
        .deleteOldImage(data)
        .then(() => {
          fetchWorks();
        })
        .catch((err) => console.error(err))
        .finally(() => setLoading(false));
      hideModal();
    }
  };

  const handleUpdateWork = () => {
    setLoading(true);
    const id = worksData[0]._id;
    const putData = {
      status: 3,
      desc: desc?.trim(),
      title: workTitle?.trim(),
    };
    works
      .updateSupervisorLeaderWork(id, putData)
      .then(() => {
        fetchWorks();
      })
      .catch((err) => console.error(err))
      .finally(() => {
        setLoading(false);
      });
  };
  const deleteWork = (id) => {
    setLoading(true);
    works
      .deleteWork(id)
      .then(() => fetchWorks())
      .catch((err) => {
        error("Маълумотни олиб ташлашда хатолик юз берди!", 2, "topRight"),
          console.error(err);
      })
      .finally(() => setLoading(false));

    hideModal();
  };
  const handleDeleteWork = (id) => {
    showBlured({
      title: "Ўчириб ташлаш!",
      maxWidth: "400px",
      height: "400px",
      withHeader: false,
      body: () => <Confirm agree={() => deleteWork(id)} cancel={hideModal} />,
    });
  };

  const reloadHandler = () => {
    fetchWorks();
  };
  if (loading) return <Spinner />;
  return (
    <Wrapper>
      <div className="top-actions">
        <LeftActions>
          <RealtimeDate />
          {/* <Filters list={buttons} active={active} handleActive={handleActive} /> */}
        </LeftActions>
        <div className="right-wrapper">
          <div className="inputs">
            <div className="select__sector__input">
              <Select
                handleChange={(value) => setSelectedGroup(value)}
                name="sector"
                size="large"
                options={groups}
                defaultVal={selectedGroup}
                placeholder="Inserted are removed"
              />
            </div>
            <div>
              <MultiDatePicker
                dates={determinedDays}
                onChange={handleChangeDateInput}
                startDate={startDate}
              />
            </div>
          </div>
          <button className="reload-button" onClick={reloadHandler}>
            <ReloadOutlined className="reload-outlined" />
          </button>
        </div>
      </div>
      {worksData?.length > 0 ? (
        <>
          <div className="work">
            <TaskCard
              canDeleteImage
              data={worksData[0]}
              description={desc}
              workTitle={workTitle}
              handleDescription={handleDescription}
              handleDeleteImage={handleDeleteImage}
              handleDeleteOldImage={handleDeleteOldImage}
              errorHelper={
                desc &&
                desc?.length < 70 &&
                workTitle &&
                workTitle.length <= 3 &&
                true
              }
              allowEdit
            />
          </div>
          <Actions>
            <div className="actions-block">
              <DeleteBtn onClick={() => handleDeleteWork(worksData[0]?._id)}>
                Ўчириш <FiTrash />
              </DeleteBtn>
              <div id="selects">
                <SaveBtn
                  isDisabled={desc.length < 10 && workTitle.length < 3 && true}
                  disabled={!(desc.length > 10 && workTitle.length > 3 && true)}
                  onClick={handleUpdateWork}
                >
                  Юбориш <IoSend />
                </SaveBtn>
              </div>
            </div>
          </Actions>
        </>
      ) : (
        <NoData>
          <Empty
            description={
              <h1>Белгиланган кун учун қилинган ишлар топилмади!</h1>
            }
          />
        </NoData>
      )}
    </Wrapper>
  );
};
